import axios, { AxiosResponse } from 'axios';
import { AdminResourceDictLanguagesResponse } from '../model/techpubs-cms';

export default class DictService {
  public async readLanguagesList(): Promise<AxiosResponse<AdminResourceDictLanguagesResponse>> {
    return axios.get<AdminResourceDictLanguagesResponse>('/api/v1/resources/dict/languages');
  }
}
